import React from "react";
import { Check, Dumbbell, Utensils, Moon, Droplets } from "lucide-react";

const ITEMS = [
  { icon: Dumbbell, label: "Zone 2 · 45 min", done: true },
  { icon: Utensils, label: "Protein-first lunch", done: true },
  { icon: Droplets, label: "2.5 L hydration", done: false },
  { icon: Moon, label: "Lights out 22:30", done: false },
];

export default function PhoneMockup() {
  return (
    <div className="relative rotate-[-4deg] hover:rotate-0 transition-transform duration-700" data-testid="get-app-phone-mockup">
      <div className="w-[260px] sm:w-[290px] aspect-[9/19] rounded-[44px] bg-[#050806] p-3 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.6)] ring-1 ring-white/10">
        <div className="relative h-full w-full rounded-[34px] bg-[var(--lc-cream)] text-[var(--lc-ink)] overflow-hidden">
          <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-6 rounded-full bg-[#050806]" />
          <div className="px-5 pt-12">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[var(--lc-muted)]">Good morning</div>
            <div className="font-serif-display text-2xl leading-tight">Today's <span className="italic">circle</span></div>

            <div className="mt-4 flex items-center gap-4 bg-white border border-[var(--lc-line)] rounded-2xl p-3">
              <svg viewBox="0 0 36 36" className="w-14 h-14 -rotate-90">
                <circle cx="18" cy="18" r="15" fill="none" stroke="var(--lc-line)" strokeWidth="3.5" />
                <circle cx="18" cy="18" r="15" fill="none" stroke="var(--lc-moss)" strokeWidth="3.5" strokeDasharray="94.2" strokeDashoffset="37" strokeLinecap="round" />
              </svg>
              <div>
                <div className="font-serif-display text-xl leading-none">4 / 6</div>
                <div className="text-[10px] tracking-[0.16em] uppercase text-[var(--lc-muted)] mt-1">Pillars closed</div>
              </div>
            </div>

            <div className="mt-4 space-y-2">
              {ITEMS.map(({ icon: Icon, label, done }) => (
                <div key={label} className="flex items-center gap-3 bg-white border border-[var(--lc-line)] rounded-xl px-3 py-2.5">
                  <Icon className="h-3.5 w-3.5 text-[var(--lc-moss)]" />
                  <span className={`flex-1 text-[12px] ${done ? "line-through text-[var(--lc-muted)]" : ""}`}>{label}</span>
                  <span className={`w-4 h-4 rounded-full grid place-items-center ${done ? "bg-[var(--lc-moss)]" : "border border-[var(--lc-line)]"}`}>
                    {done && <Check className="h-2.5 w-2.5 text-white" />}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="absolute bottom-0 inset-x-0 h-14 bg-white border-t border-[var(--lc-line)] flex items-center justify-around px-4">
            {[0, 1, 2, 3, 4].map((i) => (
              <span key={i} className={`w-1.5 h-1.5 rounded-full ${i === 0 ? "bg-[var(--lc-moss)]" : "bg-[var(--lc-line)]"}`} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
